import { useState } from 'react'
import { arrayMove } from '@dnd-kit/sortable'
import { useUpdateEnabledSections } from '../api/hooks/useSettings'
import { useUIStore } from '../stores/uiStore'
import { DashboardSection } from '../types'

export function useSectionReorder() {
  const { enabledSections, setEnabledSections } = useUIStore()
  const updateEnabledSections = useUpdateEnabledSections()

  // Local drag state for smooth dnd-kit animations
  const [dragItems, setDragItems] = useState<DashboardSection[] | null>(null)

  // Current items - use drag state during reordering, otherwise Zustand state
  const currentItems = dragItems || enabledSections

  const reorder = async (activeId: string, overId: string) => {
    if (activeId === overId) return

    const items = enabledSections
    const oldIndex = items.indexOf(activeId as DashboardSection)
    const newIndex = items.indexOf(overId as DashboardSection)
    const newOrder = arrayMove(items, oldIndex, newIndex)

    // Set local drag state immediately for smooth UI
    setDragItems(newOrder)

    // Immediately update Zustand state for instant UI feedback
    setEnabledSections(newOrder)

    try {
      // Background persistence to database
      await updateEnabledSections.mutateAsync(newOrder)

      // Clear temporary drag state - Zustand state is now correct
      setDragItems(null)
    } catch (error) {
      // Clear temporary drag state
      setDragItems(null)

      // Rollback Zustand state to previous value
      setEnabledSections(items)

      // Re-throw to allow error handling by UI
      throw error
    }
  }

  return {
    currentItems,
    reorder,
    isReordering: dragItems !== null
  }
}
